(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TradePolicyRuleDeleteController',TradePolicyRuleDeleteController);

    TradePolicyRuleDeleteController.$inject = ['$uibModalInstance', 'entity', 'TradePolicyRule'];

    function TradePolicyRuleDeleteController($uibModalInstance, entity, TradePolicyRule) {
        var vm = this;
        vm.tradePolicyRule = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TradePolicyRule.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
